<template>
  <v-card height="100%">
    <pie-chart
      v-if="chartType === 'pie'"
      :id="questionName"
      ref="piechart"
      :library="{ title: questionTitle }"
      adapter="google"
      legend="bottom"
      :data="endPoint"
      :refresh="refreshTime"
      :messages="{ empty: 'No data' }"
    />
    <column-chart
      v-else
      :id="questionName"
      ref="barchart"
      :library="{ title: questionTitle }"
      adapter="google"
      :data="endPoint"
      :refresh="refreshTime"
      :messages="{ empty: 'No data' }"
    />
  </v-card>
</template>

<script>
/* eslint-disable */
import {mapState, mapActions} from "vuex";
/* eslint-enable */

export default {
  name: "ChartKick",
  props: {
    questionName: {
      type: String,
      default: ""
    },
    questionTitle: {
      type: String,
      default: ""
    },
    // Options: pie, bar, onebar
    chartType: {
      type: String,
      default: ""
    },
    // If false, then its either a yes/no piechart
    // or a dropdown question (single)
    multipleOptions: Boolean
  },
  data() {
    return {
      refreshTime: 10
    };
  },
  computed: {
    ...mapState("survey", ["selectedSurveyNumber"]),
    surveyNum() {
      return this.selectedSurveyNumber === null ? 0 : this.selectedSurveyNumber;
    },
    endPoint() {
      const chart = this.multipleOptions ? "bar" : this.chartType
      return (
        `${process.env.VUE_APP_DRF_API_URL}/${chart}chart?format=json&pk=${this.surveyNum}&type=${this.questionName}`
      );
    }
  },
  beforeDestroy() {
    this.destroyRefresh()
  },
  methods: {
    destroyRefresh() {
      if (this.chartType === 'pie') {
        this.$refs.piechart.chart.dataSource = null;
      } else {
        this.$refs.barchart.chart.dataSource = null;
      }
    }
  }
};
</script>
